<script>
    import TooltipHybridButton from "./TooltipHybridButton.svelte";
    import {Accordion, AccordionItem, Button} from "sveltestrap";

    let isOpen = false;
    let statusMessage = "";

    function handleCollapseToggle() {
        isOpen = !isOpen;
        statusMessage = isOpen
        ? "Advanced options expanded. Use arrow keys to navigate."
        : "Advanced options collapsed.";

      // Clear status message after announcement
      setTimeout(() => {
        statusMessage = "";
      }, 1000);
    }
</script>
<div>
    <fieldset>
    <legend id="keywordLegend" class="mb-2 fs-5">
        Advanced Options
        <TooltipHybridButton searchUrlQueryParam="advanced-option" tooltip="Apply advanced filters to your search."/>
    </legend>
    <div class="d-grid gap-2">
        <button
                aria-controls="keywordCollapse"
                aria-expanded={isOpen}
                aria-label={isOpen
                      ? "Collapse keyword search options"
                      : "Expand keyword search options"}
                class="btn ae-primary btn-lg"
                class:rotated={isOpen}
                on:click={handleCollapseToggle}
        >
            <i class="bi bi-caret-down icon"></i>
        </button>
        <!--ARIA live region for status messages-->
        <div aria-live="polite" aria-atomic="true" class="visually-hidden">
            {statusMessage}
        </div>
    </div>
    <div class="custom-accordion">
        <Accordion stayOpen={true}>
            <AccordionItem active={isOpen}>
                <slot name="keywords"/>
                <div class="my-3"></div>
                <slot name="observationTypes"/>
                <div class="my-3"></div>
                <slot name="datatypes"/>
                <div class="my-3"></div>
            </AccordionItem>
        </Accordion>
    </div>
    </fieldset>
</div>

<style>
    /* 3. Hide the default Bootstrap header and button */
    :global(.custom-accordion .accordion-header) {
        display: none !important;
    }

    .rotated {
        transform: rotate(180deg);
    }
</style>